import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';

export const getVaultAccountStatusApi = (id: string): Promise<ApiResponseType<{ open_links: number }>> => {
  return authApiService.GET(`/my-vault/accounts/${id}/status/`);
};
